// extracted by mini-css-extract-plugin
export default {"slideContainer":"SlideContainer_slideContainer__-gtSx","sideBySide":"SlideContainer_sideBySide__FIyFa"};